/* ==========================================================================
   Soles District - cart drawer open fix (28 Oct 2026)

   Dawn renders <cart-drawer class="drawer is-empty"> when the page is built
   with an empty cart, and its CSS hides the item list while that class is
   there. When something later adds to the cart, renderContents() swaps the
   INSIDE of #CartDrawer for freshly rendered markup - but the class lives on
   the <cart-drawer> element itself, which is outside what gets replaced, so
   it stays. The drawer then slides open showing the shipping bar, the rating
   and the totals with a tall blank gap where the item should be.

   Dawn works around this inside product-form.js, by removing the class just
   before it calls renderContents. That fixes the product form and nothing
   else, so every other caller - our package picker, and anything added
   later - has to remember the same line. Patching renderContents itself
   fixes it once, for all of them, including Dawn's own product form.

   Deliberately a no-op if Dawn ever fixes this upstream: removing a class
   that is not there costs nothing.
   ========================================================================== */

(function () {
  /* Returns true when there is nothing left to do - either the patch is on,
     or there is no renderContents to patch. Returns false ONLY while the
     element is not defined yet, which is the case we have to wait out:
     cart-drawer.js is deferred and this file is not. */
  function patch() {
    var el = window.customElements && customElements.get('cart-drawer');
    if (!el || !el.prototype) return false;
    if (el.prototype.sdPatched) return true;

    var original = el.prototype.renderContents;
    if (typeof original !== 'function') return true;

    el.prototype.renderContents = function (parsedState) {
      this.classList.remove('is-empty');
      return original.call(this, parsedState);
    };
    el.prototype.sdPatched = true;
    return true;
  }

  if (patch()) return;

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(patch);
  } else {
    window.addEventListener('load', patch);
  }
})();
